export default "__VITE_ASSET__D1c5qK6n__"